import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { CURRENT_YEAR_PREFIX, PREV_YEAR_PREFIX } from '../constants'

import { calculateWeightAverage } from './calculateWeightAverage'
import { getCalculatedFieldsForField } from './getCalculatedFieldsForField'

interface IGetCalculatedFYFields {
  isCurrentYearField: boolean
  item: ISobCompetitor
  hpItem?: ISobCompetitor
}

const calculateWeightAverageForYear = (item: ISobCompetitor, isCurrentYearField: boolean) => {
  const prefix = isCurrentYearField ? CURRENT_YEAR_PREFIX : PREV_YEAR_PREFIX
  const sobValues = [
    item[`${prefix}Q1ActualsSob`],
    item[`${prefix}Q2ActualsSob`],
    item[`${prefix}Q3ActualsSob`],
    item[`${prefix}Q4ActualsSob`],
  ]
  const ndpValues = [
    item[`${prefix}Q1ActualsNdpUSD`],
    item[`${prefix}Q2ActualsNdpUSD`],
    item[`${prefix}Q3ActualsNdpUSD`],
    item[`${prefix}Q4ActualsNdpUSD`],
  ]
  return calculateWeightAverage({ sobValues, ndpValues })
}

export const getCalckedFYFields = ({
  isCurrentYearField,
  item,
  hpItem,
}: IGetCalculatedFYFields) => {
  const sobYearFieldToChange = isCurrentYearField
    ? 'CurrentYearFYActualsSob'
    : 'PrevYearFYActualsSob'
  const weightAverage = calculateWeightAverageForYear(item, isCurrentYearField)

  return {
    ...getCalculatedFieldsForField({ value: weightAverage, field: sobYearFieldToChange, hpItem }),
    [sobYearFieldToChange]: weightAverage,
  }
}
